/* eslint-disable react-hooks/exhaustive-deps */
import { StarFilled } from "@ant-design/icons";
import { Tooltip } from "antd";
import i18next from "i18next";
import { truncate } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { addEdge, removeElements } from "react-flow-renderer";
import styled from 'styled-components';
import { typesConfigs } from "../../../../constants/types";
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';

const initializeData = (data, activeSources) => {
  const items = [];

  const checkIfIsValid = (sources) => {
    let isValid = false;
    sources.forEach((s) => {
      if (activeSources.includes(s)) {
        isValid = true;
        return;
      }
    });

    return isValid;
  };

  const addItem = (item, level, parent, isOwnData) => {
    const sources = item.sources;
    let targets = [];

    if (parent) {
      targets = [parent];
    } else {
      targets = item.children ? item.children.map((ch) => ch.id) : [];
    }
    items.push({
      type: item.type,
      id: item.id,
      label: item.name,
      title: item.title,
      datastakeId: item.datastakeId,
      namespace: item.namespace,
      sources,
      targets,
      level,
      isOwnData,
      otherSources: item.otherSources,
      isNotConnected: item.isNotConnected,
    });
  }

  const addChildren = (children, level, parent) => {
    children.forEach((child) => {
      const sources = child.sources || [];
      if (checkIfIsValid(sources)) {
        addItem(child, level, parent);
        if (child.children) {
          addChildren(child.children, level + 1);
        }

        if (child.parents) {
          addChildren(child.parents, level - 1, child.id);
        }
      }
    });
  };

  // const ownDataIsValid = checkIfIsValid(data.sources);

  // if (ownDataIsValid) {

  addItem(data, 0, undefined, true);

  if (data.children) {
    addChildren(data.children, 1);
  }

  if (data.parents) {
    addChildren(data.parents, -1, data.id);
  }

  const levels = items.map((i) => i.level);
  const min = Math.min(...levels);
  const max = Math.max(...levels);

  const sections = [];
  for (let i = min; i <= max; i++) {
    const section = items.filter((it) => it.level === i);
    sections.push(section);
  }

  return sections;
  // }
  // return [];
};


export const sourcesColors = {
  ownData: '#2E90FA',
  supplyChainActors: '#52C41A',
  informationSources: '#FF7875',
};

const isSource = (id, con) => {
  const sourceCon = con.find((c) => c.source === id);
  if (sourceCon) {
    return true;
  }
  return false;
};

const isTarget = (id, con) => {
  const targetCon = con.find((c) => c.target === id);
  if (targetCon) {
    return true;
  }
  return false;
};

const SourceElementStyle = styled.div`
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 100%;
  border: 2px solid #113366;
  background: white;
  z-index: 100;

  &.default {
    top: 50%;
    right: 0px;
    transform: translate(50%, -50%);
  }

  &.tb {
    bottom: 0px;
    left: 50%;
    transform: translate(-50%, 50%);
  }
`;

const TargetElementStyle = styled.div`
  position: absolute;
  width: 0; 
  height: 0; 
  
  &.default {
    top: 50%;
    left: 0px;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 8px solid #113366; 
    z-index: 100;
    transform: translate(-100%, -50%);
  }

  &.tb {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 8px solid #113366;
    top: 0px;
    left: 50%;
    transform: translate(-50%, -100%);
  }
`;

const InnerStyle = styled.div`
  display: flex;
  flex-direction: column;

  label {
    text-align: left;
    margin: 0px;
  }

  .header-cont {
    display: flex;
    margin-bottom: 0px !important;

    .own-data {
      width: 7px;
      background: #2E90FA;
      border-right: 1px solid black;
    }

    .header {
      display: flex;
      flex-direction: column;
      flex: 1;

      padding: 6px 8px 5px 8px;
      .type {
        font-size: 9px;
        font-weight: 700;
      }

      .label {
        font-size: 11px;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 120px;
      }
    }

    &.active .label {
      color: #2E90FA;
      font-weight: 700;
      text-decoration-line: underline;
    }
  }

  .sources {
    padding: 2px 8px 2px 8px;
    border-top: 1px solid black;
    display: flex;
    gap: 4px;
    
    .item {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .featured-data {
      svg {
        fill: #FFC700;
        font-size: 12px;
        margin-top: 1px;
      }
    }

    .legend {
      padding: 3px;
      border: 2px solid white;
      border-radius: 100%;
    }

    label {
      color: #595959;
      font-size: 8px;
      margin-top: 1px;
    }

    &.active {
      background: #2E90FA;

      label {
        color: white;
      }
    }
  }
`;

const Header = ({
  config,
  isOwnData = false,
  isActive = false,
}) => {
  const headerConfig = useMemo(() =>
    typesConfigs.find((c) => c.type === config.type), [config]);

  return headerConfig ? (
    <div className={formatClassname(["header-cont", isActive && 'active'])}>
      {isOwnData && (
        <div className="own-data" />
      )}
      <div className="header">
        <Tooltip title={config.title}>
          <div style={{
            width: '100%',
            background: '#fff',
            textAlign: 'start',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flexStart',
            alignItems: 'center',
            flexWrap: 'nowrap'
          }}>
            <label className="type" style={{ color: headerConfig.color, wordBreak: 'break-all' }}>
              {truncate(config.title, { length: 30 })}
            </label>
          </div>
        </Tooltip>
        <Tooltip title={config.label}>
          <div style={{
            width: '100%',
            background: '#fff',
            textAlign: 'start',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flexStart',
            alignItems: 'center',
            flexWrap: 'nowrap'
          }}>
            <label className="label" style={{ wordBreak: 'break-all' }}>
              {truncate(config.label, { length: 32 })}
            </label>
          </div>
        </Tooltip>
      </div>
    </div>
  ) : null;
};

const Sources = ({
  sources = [],
  supplyChainActors = [],
  informationSources = [],
  ownDataSources = [],
  isActive = false,
  isAnalysis = false,
}) => {
  const userSupplyChainActors = useMemo(() =>
    (supplyChainActors || []).filter((s) => sources.includes(s.id)), [sources, supplyChainActors]);

  const userInformationSources = useMemo(() =>
    (informationSources || []).filter((s) => sources.includes(s.id)), [sources, informationSources]);

  const hasOwnData = useMemo(() => ownDataSources.filter(s => sources.includes(s.id)).length > 0, [sources, ownDataSources]);

  return (
    <div className={formatClassname([isActive && 'active', 'sources'])}>
      {userSupplyChainActors.length !== 0 && (
        <div className="item">
          <div className="legend" style={{ background: sourcesColors.supplyChainActors }} />
        </div>
      )}
      {userInformationSources.length !== 0 && (
        <div className="item">
          <div className="legend" style={{ background: sourcesColors.informationSources }} />
        </div>
      )}
      {hasOwnData ? isAnalysis ? (
        <StarFilled className="featured-data" />
      ) : (
        <div className="item">
          <div className="legend" style={{ background: sourcesColors.ownData }} />
        </div>
      ) : null}
      <div className="item">
        <label>{sources.length} Source(s)</label>
      </div>
    </div >
  );
};

export const TBInitialItems = [
  {
    id: '1',
    data: {
      label: (
        <>
          <InnerStyle>
            <Header
              isActive={false}
              config={{ type: 'globalBuyer', title: 'Global Buyer', label: 'Name Placeholder 1' }}
              isOwnData={true}
            />
            <div className="sources">
              <div className="item">
                <div className="legend" style={{ background: sourcesColors.ownData }} />
              </div>
              <div className="item">
                <label>1 Source(s)</label>
              </div>
            </div>
          </InnerStyle>
          <TargetElementStyle className="tb" />
        </>
      ),
    },
    className: 'node',
    position: {
      x: 0,
      y: 0,
    },
    sourcePosition: 'bottom',
    targetPosition: 'top',
    style: {
      padding: 0,
    },
  },
  {
    id: '2',
    data: {
      label: (
        <>
          <SourceElementStyle className="tb" />
          <InnerStyle>
            <Header
              isActive={false}
              config={{ type: 'mineSite', title: 'Mine Site', label: 'Name Placeholder 2' }}
            />
            <div className="sources">
              <div className="item">
                <div className="legend" style={{ background: sourcesColors.ownData }} />
              </div>
              <div className="item">
                <label>1 Source(s)</label>
              </div>
            </div>
          </InnerStyle>
        </>
      ),
    },
    className: 'node',
    position: {
      x: 180,
      y: -180,
    },
    sourcePosition: 'bottom',
    targetPosition: 'top',
    style: {
      padding: 0,
    },
  },
  {
    id: '3',
    data: {
      label: (
        <>
          <SourceElementStyle className="tb" />
          <InnerStyle>
            <Header
              isActive={false}
              config={{ type: 'mineSite', title: 'Mine Site', label: 'Name Placeholder 3' }}
            />
            <div className="sources">
              <div className="item">
                <div className="legend" style={{ background: sourcesColors.ownData }} />
              </div>
              <div className="item">
                <label>1 Source(s)</label>
              </div>
            </div>
          </InnerStyle>
        </>
      ),
    },
    className: 'node',
    position: {
      x: -180,
      y: -180,
    },
    sourcePosition: 'bottom',
    targetPosition: 'top',
    style: {
      padding: 0,
    },
  },
  {
    id: '2-1',
    source: '2',
    target: '1',
    style: {
      stroke: '#113366',
      strokeWidth: 1,
    }
  },
  {
    id: '3-1',
    source: '3',
    target: '1',
    style: {
      stroke: '#113366',
      strokeWidth: 1,
    }
  },
];

export const LRInitialItems = [
  {
    id: '1',
    data: {
      label: (
        <>
          <InnerStyle>
            <Header
              isActive={false}
              config={{ type: 'globalBuyer', title: 'Global Buyer', label: 'Name Placeholder 1' }}
              isOwnData={true}
            />
            <div className="sources">
              <div className="item">
                <div className="legend" style={{ background: sourcesColors.ownData }} />
              </div>
              <div className="item">
                <label>1 Source(s)</label>
              </div>
            </div>
          </InnerStyle>
          <TargetElementStyle className="default" />
        </>
      ),
    },
    className: 'node',
    position: {
      x: 0,
      y: 0,
    },
    sourcePosition: 'right',
    targetPosition: 'left',
    style: {
      padding: 0,
    },
  },
  {
    id: '2',
    data: {
      label: (
        <>
          <SourceElementStyle className="default" />
          <InnerStyle>
            <Header
              isActive={false}
              config={{ type: 'mineSite', title: 'Mine Site', label: 'Name Placeholder 2' }}
            />
            <div className="sources">
              <div className="item">
                <div className="legend" style={{ background: sourcesColors.ownData }} />
              </div>
              <div className="item">
                <label>1 Source(s)</label>
              </div>
            </div>
          </InnerStyle>
        </>
      ),
    },
    className: 'node',
    position: {
      x: -280,
      y: -150,
    },
    sourcePosition: 'right',
    targetPosition: 'left',
    style: {
      padding: 0,
    },
  },
  {
    id: '3',
    data: {
      label: (
        <>
          <SourceElementStyle className="default" />
          <InnerStyle>
            <Header
              isActive={false}
              config={{ type: 'mineSite', title: 'Mine Site', label: 'Name Placeholder 3' }}
            />
            <div className="sources">
              <div className="item">
                <div className="legend" style={{ background: sourcesColors.ownData }} />
              </div>
              <div className="item">
                <label>1 Source(s)</label>
              </div>
            </div>
          </InnerStyle>
        </>
      ),
    },
    className: 'node',
    position: {
      x: -280,
      y: 150,
    },
    sourcePosition: 'right',
    targetPosition: 'left',
    style: {
      padding: 0,
    },
  },
  {
    id: '2-1',
    source: '2',
    target: '1',
    style: {
      stroke: '#113366',
      strokeWidth: 1,
    }
  },
  {
    id: '3-1',
    source: '3',
    target: '1',
    style: {
      stroke: '#113366',
      strokeWidth: 1,
    }
  },
];

const getReports = (nodes) => {
  let mineSites = 0;
  let tierOne = 0;
  let scp = 0;
  let total = nodes.length;
  const levels = nodes.map((n) => n.level);
  const maxLevel = Math.max(...levels);

  nodes.forEach((node) => {
    if (node.config) {
      if (node.config.type === 'mineSite') {
        mineSites++;
      } else {
        scp++;
        if (node.level === maxLevel - 1) {
          tierOne++;
        }
      }
    }
  });

  return {
    mineSites,
    tierOne,
    scp,
    total,
  };
}

export function useNodes({
  data,
  setActiveNode = () => { },
  supplyChainActors = null,
  informationSources = null,
  ownDataSources = null,
  activeSources = [],
  activeNode = null,
  flow = 'TB',
  isAnalysis = false,
  type = 'default',
}) {
  const [X, Y] = flow === 'LR' ? [250, -110] : [-200, 180];
  const [initElements, setInitElements] = useState();
  const [elements, setElements] = useState([]);
  const [instance, setInstance] = useState(null);
  const [reports, setReports] = useState({});

  const items = useMemo(() => {
    if (data && Object.keys(data).length && activeSources) {
      return initializeData(data, activeSources);
    }
    return null;
  }, [data, activeSources]);

  const allItems = useMemo(() => {
    if (items) {
      const all = [];
      items.forEach((i) => i.forEach((a) => {
        all.push(a);
      }));
      return all;
    }

    return null;
  }, [items,]);

  const onElementsRemove = (elementsToRemove) =>
    setElements((els) => removeElements(elementsToRemove, els));

  const onConnect = (params) => setElements((els) => addEdge({
    ...params, type: 'buttonedge',
  }, els));

  const onLoad = (reactFlowInstance) => {
    setTimeout(() => reactFlowInstance.fitView(), 100);
    setInstance(reactFlowInstance);
  };

  const setAllPositions = (nodes) => {
    const groupedByLevel = {};

    nodes.forEach((n) => {
      if (groupedByLevel[n.level]) {
        groupedByLevel[n.level].push(n);
      } else {
        groupedByLevel[n.level] = [n];
      }
    });

    const elements = [];
    Object.entries(groupedByLevel).forEach(([k, v]) => {
      let group = [];
      if (flow === 'LR') {
        const maxChildY = ((v.length + 1) * (Y / 2));
        const prevGroupedByLevel = groupedByLevel[k - 1];
        const parentX = prevGroupedByLevel ? prevGroupedByLevel[0].position.x : 0;
        v.forEach((el, i) => {
          group.push({
            ...el,
            position: {
              x: parentX + X,
              y: maxChildY - (Y * (i + 1)),
            },
          });
        });
        elements.push(...group);
        groupedByLevel[k] = group;
      } else {
        const maxChildX = ((v.length + 1) * (X / 2));
        const prevGroupedByLevel = groupedByLevel[k - 1];
        const parentY = prevGroupedByLevel ? prevGroupedByLevel[0].position.y : 0;
        v.forEach((el, i) => {
          group.push({
            ...el,
            position: {
              y: parentY + Y,
              x: maxChildX - (X * (i + 1)),
            },
          });
        });
        elements.push(...group);
        groupedByLevel[k] = group;
      }
    });

    return elements;
  };

  const initializeItems = () => {
    let nodes = [];
    const con = [];
    const data = items;

    const isOwnData = (sources) => {
      let isValid = false;
      sources.forEach((s) => {
        if (ownDataSources.filter((l) => l.id === s).length !== 0) {
          isValid = true;
          return;
        }
      });
      return isValid;
    };

    data.forEach((items, i) => {
      items.forEach((item) => {
        const itemSources = item.sources
          ? item.sources.filter((s) => activeSources.includes(s)) : null;
        const nodeSupplyChainActors = itemSources ?
          (supplyChainActors || []).filter((s) => itemSources.includes(s.id))
          : [];
        const nodeInformationSources = itemSources ?
          (informationSources || []).filter((s) => itemSources.includes(s.id))
          : [];

        if (item.targets) {
          item.targets.forEach((target) => {
            if (allItems.find((i) => i.id === target)) {
              const last = con.find((c) => c.target === target && c.source === item.id);
              if (!last && !item.isNotConnected) {
                con.push({
                  source: item.id,
                  target: target,
                  isInfoSource: nodeInformationSources.length > 0,
                  isOwnData: isOwnData(itemSources),
                  isSupplyChainActor: nodeSupplyChainActors.length > 0,
                });
              }
            }
          })
        }

        if (!nodes.find((n) => n.id === item.id)) {
          nodes.push({
            id: item.id,
            sourcePosition: flow === 'LR' ? 'left' : 'bottom',
            position: { x: 0, y: 0 },
            type: 'node',
            config: {
              ...item,
              isSource: isSource(item.id, con),
              isTarget: isTarget(item.id, con),
              nodeSupplyChainActors,
              nodeInformationSources,
            },
            level: i,
          });
        }
      });
    });

    let edges = [];
    con.forEach(({ source, target, isInfoSource, isOwnData, isSupplyChainActor }) => {
      edges.push({
        id: `${source}-${target}`,
        source,
        target,
        isInfoSource,
        type: 'edge',
        isOwnData,
        isSupplyChainActor
      });
    });

    nodes = setAllPositions(nodes);

    if (type === 'SC_PROJECT') {
      setReports(getReports(nodes));
    }

    setInitElements([
      ...nodes,
      ...edges,
    ]);
  };

  const getStroke = (el) => {
    if (el.isOwnData) {
      return '#113366';
    }
    if (el.isSupplyChainActor) {
      return sourcesColors.supplyChainActors;
    }
    if (el.isInfoSource) {
      return sourcesColors.informationSources;
    }

    return '#113366';
  }

  useEffect(() => {
    if (initElements) {
      setElements(initElements.map((el) => {
        switch (el.type) {
          case 'edge':
            return {
              id: el.id,
              source: el.source,
              target: el.target,
              style: {
                stroke: getStroke(el),
                strokeWidth: 1,
              }
            };
          case 'node':
            return {
              id: el.id,
              data: {
                label: (
                  <>
                    {el.config.isSource && <SourceElementStyle className={flow === 'LR' ? 'default' : 'tb'} />}
                    <InnerStyle
                      onClick={() => {
                        setActiveNode(el.config);
                      }}
                    >
                      <Header
                        isActive={(activeNode) ? activeNode.id === el.id : false}
                        config={el.config}
                        isOwnData={el.config.isOwnData}
                      />
                      <Sources
                        isActive={(activeNode) ? activeNode.id === el.id : false}
                        sources={[...el.config.sources].filter((s) => activeSources.includes(s))}
                        supplyChainActors={supplyChainActors}
                        informationSources={informationSources}
                        ownDataSources={ownDataSources}
                        isAnalysis={isAnalysis}
                      />
                    </InnerStyle>
                    {el.config.isTarget && <TargetElementStyle className={flow === 'LR' ? 'default' : 'tb'} />}
                  </>
                ),
              },
              className: 'node',
              position: el.position,
              sourcePosition: flow === 'LR' ? 'right' : 'bottom',
              targetPosition: flow === 'LR' ? 'left' : 'top',
              style: {
                padding: 0,
              },
            };
          default:
            return null;
        }
      }));
    }
  }, [initElements, activeNode]);

  useEffect(() => {
    if (items) {
      initializeItems();
    }
  }, [items, supplyChainActors, informationSources, activeSources, flow]);

  useEffect(() => {
    setActiveNode(null);
  }, [i18next.language]);

  useEffect(() => {
    if (instance) {
      setTimeout(() => instance.fitView(), 100);
    }
  }, [flow, data]);

  return {
    elements,
    initElements,
    onElementsRemove,
    onConnect,
    onLoad,
    reports,
  };
}
